/**
 * Настройка «Автоматически включать звук» у аудио/видео.
 *
 * Источник правды — АККАУНТ: users.auto_sound, приходит в /user/me и в
 * ответе логина, живёт в AuthContext. Компоненты читают её хуком
 * useAutoSound (hooks/useAutoSound.ts) — оттуда же, откуда весь профиль.
 *
 * Зеркало в localStorage — узкая подстраховка на ОДИН интервал: первые
 * миллисекунды после F5, пока запрос профиля в полёте, а видео на
 * странице уже стартует. Без него плеер успел бы включиться с дефолтным
 * поведением и переключиться на глазах.
 *
 * Поэтому зеркало: (1) обновляется при каждом получении профиля
 * (api/auth.ts) и при переключении тумблера, (2) ЧИСТИТСЯ при выходе из
 * аккаунта — иначе на общем компьютере следующий юзер до первого
 * /user/me унаследовал бы чужую настройку.
 */

const KEY = 'umnik.autoSound'
const EVENT = 'umnik:auto-sound-change'

/** Синхронное чтение зеркала. Компонентам нужен useAutoSound() — он берёт
 *  значение из аккаунта, а сюда падает только пока профиль не загружен. */
export function readAutoSound(): boolean {
	try {
		return localStorage.getItem(KEY) === '1'
	} catch {
		return false // private mode / отключённое хранилище
	}
}

/** Выход из аккаунта: чужая настройка не должна достаться следующему
 *  юзеру этого браузера. */
export function clearAutoSound(): void {
	try {
		if (localStorage.getItem(KEY) === null) return
		localStorage.removeItem(KEY)
	} catch {
		return
	}
	window.dispatchEvent(new CustomEvent(EVENT, { detail: false }))
}

/** Записать значение, пришедшее с сервера. Событие шлём только при
 *  реальном изменении — иначе поллинг /user/me раз в 15 секунд дёргал бы
 *  ре-рендер всех подписчиков. */
export function cacheAutoSound(value: boolean | undefined | null): void {
	if (value === undefined || value === null) return
	const next = value ? '1' : '0'
	try {
		if (localStorage.getItem(KEY) === next) return
		localStorage.setItem(KEY, next)
	} catch {
		return
	}
	window.dispatchEvent(new CustomEvent(EVENT, { detail: value }))
}

/** Подписка на изменения: тумблер в этой вкладке (CustomEvent) и
 *  переключение в соседней вкладке (storage). */
export function subscribeAutoSound(cb: (value: boolean) => void): () => void {
	const onCustom = (e: Event) => cb(Boolean((e as CustomEvent).detail))
	const onStorage = (e: StorageEvent) => {
		if (e.key === KEY) cb(e.newValue === '1')
	}
	window.addEventListener(EVENT, onCustom)
	window.addEventListener('storage', onStorage)
	return () => {
		window.removeEventListener(EVENT, onCustom)
		window.removeEventListener('storage', onStorage)
	}
}
